// This is generated.  Alter it in blockGroups/formElements/types/MultiPickerShortText.js
/* eslint-disable no-unused-vars */
const { Type } = require('@sinclair/typebox');
const { merge } = require('lodash');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
module.exports = {
  asDataDictionary: function asDataDictionary(hNode, context) {
    const {
      id,
      title,
      propertyName,
      foreignNamespace,
      foreignRelation,
      required,
      minLength,
      maxLength,
      pattern,
    } = hNode;

    // This block tells us the foreign namespaces/relations should exist
    // and the filters will tell us about properties we'd expect to be on there
    let [_subDataDictionary = {}, _partialTypeDefinition = {}] =
      hNode.children?.reduce(
        ([sdd, ptd], child) => {
          const [_subDataDictionary = {}, _partialTypeDefinition = {}] =
            context.extractFromChild(child, context);
          return [
            merge(sdd, _subDataDictionary),
            moduleRegistration.mergePartialTypeDefinitions(
              ptd,
              _partialTypeDefinition,
              context,
            ),
          ];
        },
        [{}, {}],
      ) ?? [{}, {}];

    // Merge the child subdictionaries with any filter-contributed data
    const subDataDictionary = _subDataDictionary;

    const { isOptional: optional, schemaOptions } =
      moduleRegistration.resolveFieldFlags(required, context);

    // Helper to wrap a schema as optional if needed
    const maybeOptional = (schema) =>
      optional ? Type.Optional(schema) : schema;

    const normalizedPropertyName =
      propertyName || `${foreignNamespace}:${foreignRelation}`;
    const schemaTitle = title || normalizedPropertyName;

    // Build the array schema with string items
    const itemSchema = Type.String({
      title: 'Item',
      'x-dataType': 'string',
      ...(schemaOptions['x-required'] || minLength != null
        ? {
            minLength: schemaOptions['x-required']
              ? Math.max(1, minLength || 0)
              : minLength,
          }
        : {}),
      ...(maxLength != null ? { maxLength } : {}),
      ...(pattern ? { pattern } : {}),
    });

    const arraySchema = maybeOptional(
      Type.Array(itemSchema, {
        title: schemaTitle,
        'x-id': id,
        'x-dataType': 'array',
        ...(schemaOptions['x-required'] ? { minItems: 1 } : {}),
        'x-propertyName': normalizedPropertyName,
        ...schemaOptions,
        'x-foreignNamespace': foreignNamespace,
        'x-foreignRelation': foreignRelation,
      }),
    );

    // The partial type definition is a plain object with the property schema
    const partialTypeDefinition = {
      [normalizedPropertyName]: arraySchema,
    };

    return [subDataDictionary, partialTypeDefinition];
  },
};
moduleRegistration.registerHNodeType(
  'formElements',
  'MultiPickerShortText',
  module.exports,
);
